import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function Companies({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Companies'}  email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

